"use client"
import { ContactForm } from './contactForm'


//  Default export for the ContactPage component
const ContactPage = () => {
    return (<ContactForm />)
}

export default ContactPage;